const domains = {
    web: {
        sea: 'web-api.komoejoy-sea.com',
        komoe: 'web-api.komoejoy.com',
        jp: 'web-api.bilibili.co.jp',
    },
    passport: {
        sea: 'web-login.komoejoy-sea.com/komoe',
        komoe: 'web-login.komoejoy.com/komoejoy',
        jp: 'web-login.bilibili.co.jp',
    },
    cs: {
        sea: 'cs-api.komoejoy-sea.com',
        komoe: 'cs-api.komoejoy.com',
        jp: 'cs-api.bilibili.co.jp',
    },
    csMng: {
        komoe: 'cs-mng.komoejoy.com',   
        jp: 'cs-mng.bilibili.co.jp',
    },
    pay: {
        sea: 'web-pay.komoejoy-sea.com',
        komoe: 'web-pay.komoejoy.com',
        jp: '',
    },
    uploadS: {
        sea: 'upload-api.komoejoy-sea.com',
        komoe: 'upload-api.komoejoy.com',
        jp: 'upload-api.bilibili.co.jp'
    },
    upload: {
        komoe: 'l13-upload-api.komoejoy.com',
        jp: 'l13-upload-api.bilibili.co.jp'
    }
};

export default domains;